import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitokolhapurcabs() {



  const cardData =
  {
    keyword: 'Mumbai to Kolhapur Cab',
    heading: 'Shambhu Cabs: Mumbai to Kolhapur Cab ',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Kolhapur Cab services, providing safe, comfortable, and seamless travel for families, friends, pilgrims, and corporate travelers heading to Kolhapur. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and relaxing journey from Mumbai to Kolhapur with spacious seating and well-maintained vehicles. With flexible one-way and round-trip options, professional chauffeurs, and 24/7 booking support, Shambhu Cabs makes your long-distance travel easy, stress-free, and affordable. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Kolhapur cab services for all travelers seeking comfort, safety, and reliability throughout the journey.',

    top: 'Top Places to Visit in Kolhapur with Shambhu Cabs',

  "topPlaces": [
    {
      "title": "Mahalaxmi Temple",
      "description": "The Mahalaxmi Temple, also known as the Ambabai Temple, is one of the Shakti Peethas and Kolhapur’s most revered spiritual landmarks. Built in the 7th century by the Chalukyas, it showcases intricate stone carvings, a sacred idol of Goddess Mahalaxmi, and a divine atmosphere that attracts devotees year-round. The temple complex remains a major cultural and religious center of Maharashtra."
    },
    {
      "title": "New Palace (Shahu Palace)",
      "description": "The New Palace is an architectural masterpiece built in black polished stone that served as the royal residence of Chhatrapati Shahu Maharaj. The palace houses the Shahaji Chhatrapati Museum, featuring a rich collection of royal artifacts, personal belongings, hunting trophies, paintings, and historical documents. Its blend of Jain and Hindu architectural styles adds to its grandeur."
    },
    {
      "title": "Rankala Lake",
      "description": "Rankala Lake is a scenic waterbody created during the reign of the Chalukya dynasty. Surrounded by gardens, walking paths, and street food stalls, the lake is a popular spot for evening strolls and boating. The serene atmosphere, along with the iconic Shalini Palace nearby, makes it a favorite recreational destination for tourists and locals."
    },
    {
      "title": "Panhala Fort",
      "description": "Panhala Fort is one of the largest and most historically significant forts in Maharashtra. Known for its association with Maharani Tarabai and Chhatrapati Shivaji Maharaj, the fort offers breathtaking valley views and architectural wonders like the Sajja Kothi and Andhar Bavadi. Its strategic location and rich Maratha history make it a major attraction near Kolhapur."
    },
    {
      "title": "Jyotiba Temple",
      "description": "Situated on a hill 17 km from Kolhapur, the Jyotiba Temple is a sacred Hindu pilgrimage site dedicated to Lord Jyotiba, believed to be an incarnation of Shiva. The temple becomes a sea of pink during the annual fairs, when devotees celebrate by throwing 'gulal'. Its unique rituals and hilltop location attract pilgrims and cultural enthusiasts."
    },
    {
      "title": "Shalini Palace",
      "description": "Shalini Palace is a beautiful lakeside palace built in 1931 using black stone and Italian marble. Surrounded by lush gardens and located on the shores of Rankala Lake, the palace once served as a royal residence and later a luxury hotel. Its Indo-European architecture, stained-glass windows, and peaceful ambience make it a striking heritage spot."
    },
    {
      "title": "Dajipur Wildlife Sanctuary",
      "description": "Located on the Kolhapur–Belgaum road, the Dajipur Wildlife Sanctuary—also known as the Bison Sanctuary—is home to Indian bison (gaur), deer, leopards, and diverse bird species. Nestled amidst the Sahyadri mountains, it offers jungle safaris, trekking trails, and scenic viewpoints perfect for nature lovers and adventure seekers."
    },
    {
      "title": "Bhavani Mandap",
      "description": "Bhavani Mandap is a historical monument built during the reign of Chhatrapati Shahu Maharaj and served as a royal court and administrative center. The structure includes carved pillars, spacious halls, ancient weapons, and a shrine dedicated to Goddess Bhavani. It stands as a reminder of Kolhapur’s glorious Maratha heritage."
    }
  ],


 "services": [
  {
    "name": "Mumbai Kolhapur Taxi Service",
    "description": "Mumbai Kolhapur Taxi Service offers reliable, comfortable, and safe intercity travel between Mumbai and Kolhapur. Ideal for family trips, business travel, and pilgrimages, this service provides well-maintained cars, professional chauffeurs familiar with all routes, and flexible pickup options. Travelers can enjoy a stress-free journey with timely arrivals, highway comfort, and multiple vehicle choices including sedans, SUVs, and premium cabs."
  },
  {
    "name": "Kolhapur Mumbai One-Way Cab",
    "description": "Kolhapur Mumbai One-Way Cab is perfect for travelers needing a single-drop service from Kolhapur to Mumbai. With no return charges, passengers can save money while enjoying comfortable seating, professional drivers, and hassle-free intercity travel. The service caters to corporate travelers, tourists, and families, ensuring safety, on-time arrival, and scenic route experience along the Mumbai–Kolhapur highway."
  },
  {
    "name": "Intercity Cab Mumbai Kolhapur",
    "description": "Intercity Cab Mumbai Kolhapur provides smooth, reliable, and efficient long-distance travel between the two cities. Passengers can choose from a variety of vehicles such as sedans, SUVs, and premium cabs for a comfortable journey. This service prioritizes punctuality, safety, highway navigation expertise, and round-the-clock assistance, making it suitable for business trips, weekend getaways, and family travel."
  },
  {
    "name": "Mumbai to Kolhapur Car Rental",
    "description": "Mumbai to Kolhapur Car Rental offers flexible and affordable car hire options for long-distance journeys. Travelers can book sedans, SUVs, or luxury cars with trained chauffeurs for a safe, comfortable, and relaxing experience. Perfect for tourists, corporate clients, and families, this service allows door-to-door pickup and drop, customizable itineraries, and full control over travel schedules."
  },
  {
    "name": "Best Cab Mumbai Kolhapur",
    "description": "Best Cab Mumbai Kolhapur is known for its premium fleet, professional drivers, and punctual service. Passengers enjoy well-maintained vehicles with AC comfort, ample luggage space, and smooth rides across the Mumbai–Kolhapur highway. Ideal for corporate travel, family trips, and intercity commutes, this cab service ensures convenience, safety, and a stress-free journey experience."
  },
  {
    "name": "Affordable Mumbai Kolhapur Taxi",
    "description": "Affordable Mumbai Kolhapur Taxi provides budget-friendly intercity travel without compromising on comfort or safety. Ideal for students, families, and frequent travelers, this service offers transparent pricing, well-maintained vehicles, and reliable drivers. Passengers can enjoy door-to-door pickup, on-time arrivals, and a smooth highway journey at cost-effective rates."
  },
  {
    "name": "Chauffeur Cab Mumbai Kolhapur",
    "description": "Chauffeur Cab Mumbai Kolhapur offers professional, experienced drivers for a premium intercity travel experience. Perfect for executives, business travelers, and VIP clients, this service ensures timely pick-ups, courteous service, and safe long-distance travel. Passengers can relax during the journey while drivers manage traffic, routes, and comfort throughout the Mumbai–Kolhapur trip."
  },
  {
    "name": "Sedan Cab Mumbai Kolhapur",
    "description": "Sedan Cab Mumbai Kolhapur provides a comfortable and economical option for small families, solo travelers, and corporate clients. These sedans are fully maintained, equipped with AC, and driven by experienced chauffeurs to ensure a safe, smooth, and timely journey between Mumbai and Kolhapur. Ideal for budget-conscious travelers seeking reliable intercity transport."
  },
  {
    "name": "SUV Cab Mumbai Kolhapur",
    "description": "SUV Cab Mumbai Kolhapur is perfect for families, groups, and travelers with extra luggage, offering spacious and comfortable rides for long-distance journeys. These vehicles feature modern amenities, safety features, and professional drivers trained for highway travel. Passengers can enjoy a smooth and luxurious experience, making extended trips between Mumbai and Kolhapur stress-free."
  },
  {
    "name": "Long-Distance Cab Mumbai Kolhapur",
    "description": "Long-Distance Cab Mumbai Kolhapur specializes in extended intercity travel, ensuring maximum comfort, safety, and punctuality. Ideal for weekend trips, business travel, or pilgrimages, this service provides well-equipped vehicles, experienced drivers, and clear fare structures. Travelers can enjoy a hassle-free journey with route flexibility, clean cars, and on-time arrivals."
  },
  {
    "name": "Mumbai Kolhapur Outstation Cab",
    "description": "Mumbai Kolhapur Outstation Cab offers convenient, safe, and comfortable transportation for travelers venturing outside Mumbai. With multiple vehicle options, well-trained chauffeurs, and flexible booking schedules, this service caters to families, tourists, and corporate clients. Passengers benefit from smooth rides, timely pickups, and stress-free intercity travel between Mumbai and Kolhapur."
  },
  {
    "name": "24×7 Taxi Mumbai Kolhapur",
    "description": "24×7 Taxi Mumbai Kolhapur provides round-the-clock intercity cab services for travelers with any schedule. Early morning, late-night, or emergency trips are easily accommodated. The service ensures prompt pick-ups, reliable vehicles, professional drivers, and safe travel, making it ideal for urgent travel, business commitments, or last-minute weekend trips."
  },
  {
    "name": "Premium Cab Mumbai Kolhapur",
    "description": "Premium Cab Mumbai Kolhapur delivers a luxury travel experience with high-end vehicles, executive sedans, and chauffeur-driven SUVs. Perfect for corporate clients, VIPs, and travelers seeking extra comfort, this service emphasizes punctuality, safety, privacy, and exceptional travel standards throughout the journey between Mumbai and Kolhapur."
  },
  {
    "name": "Mumbai Kolhapur Family Cab",
    "description": "Mumbai Kolhapur Family Cab is designed for family travel, providing spacious, comfortable, and safe rides. Vehicles are equipped with modern amenities and driven by courteous chauffeurs experienced in long-distance travel. This service ensures a hassle-free, enjoyable, and relaxed intercity journey suitable for family vacations, sightseeing, or pilgrimages."
  },
  {
    "name": "Highway Cab Mumbai Kolhapur",
    "description": "Highway Cab Mumbai Kolhapur specializes in safe, smooth, and scenic travel along the Mumbai–Kolhapur highway. Experienced drivers ensure optimal highway navigation, minimizing delays and providing comfort throughout the journey. Ideal for families, corporate travelers, and tourists, this service combines speed, safety, and convenience for a pleasant travel experience."
  },
  {
    "name": "Fast Mumbai Kolhapur Cab",
    "description": "Fast Mumbai Kolhapur Cab focuses on quick and punctual long-distance travel, catering to travelers with time-sensitive schedules. Professional drivers and well-maintained vehicles ensure that passengers reach their destination safely and on time. Ideal for business trips, airport transfers, and urgent travel requirements."
  },
  {
    "name": "Corporate Cab Mumbai Kolhapur",
    "description": "Corporate Cab Mumbai Kolhapur provides professional intercity transportation tailored for business executives and corporate teams. The service features premium vehicles, courteous drivers, privacy, punctual pickups, and comfortable seating. Perfect for meetings, events, client visits, and official travel between Mumbai and Kolhapur."
  },
  {
    "name": "Safe Taxi Mumbai Kolhapur",
    "description": "Safe Taxi Mumbai Kolhapur prioritizes passenger safety, comfort, and reliability. Vehicles are fully sanitized, maintained, and driven by experienced chauffeurs trained in highway safety. This service ensures peace of mind for families, solo travelers, and corporate passengers during their journey between Mumbai and Kolhapur."
  }
],

"tableData": [
  ["Mumbai Kolhapur Taxi Service", "Kolhapur Mumbai One-Way Cab"],
  ["Intercity Cab Mumbai Kolhapur", "Mumbai to Kolhapur Car Rental"],
  ["Best Cab Mumbai Kolhapur", "Affordable Mumbai Kolhapur Taxi"],
  ["Chauffeur Cab Mumbai Kolhapur", "Sedan Cab Mumbai Kolhapur"],
  ["SUV Cab Mumbai Kolhapur", "Long-Distance Cab Mumbai Kolhapur"],
  ["Mumbai Kolhapur Outstation Cab", "24×7 Taxi Mumbai Kolhapur"],
  ["Premium Cab Mumbai Kolhapur", "Mumbai Kolhapur Family Cab"],
  ["Highway Cab Mumbai Kolhapur", "Fast Mumbai Kolhapur Cab"],
  ["Corporate Cab Mumbai Kolhapur", "Safe Taxi Mumbai Kolhapur"]
],



"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Kolhapur Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers dependable Mumbai to Kolhapur cab services, perfect for temple visits, business travel, and long-distance journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and well-serviced cabs designed to provide a smooth and comfortable journey to Kolhapur."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Long Highway Routes",
    "WhyChoosedescription": "Our skilled drivers are familiar with the Mumbai to Kolhapur highway route, ensuring safe, smooth, and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Get clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to Kolhapur cab ride hassle-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available 24/7 to assist you with bookings, travel queries, and real-time route support."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Outstation Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans to suit your Mumbai to Kolhapur travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Every cab is thoroughly cleaned and sanitized before each trip, ensuring a hygienic and secure travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and smooth service, making your Mumbai to Kolhapur journey stress-free and convenient."
  }
]

















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Kolhapur cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Kolhapur cab services with professional and experienced drivers.',
  },
  {
    question: 'How can I book a Mumbai to Kolhapur cab with Shambhu Cabs?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for quick assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Kolhapur cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and luxury cars suitable for long-distance travel from Mumbai to Kolhapur.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Kolhapur route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Mumbai to Kolhapur route to ensure a safe and smooth journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Kolhapur cab?',
    answer: 'Absolutely. You can choose your preferred pickup point in Mumbai and drop-off location anywhere in Kolhapur.',
  },
  {
    question: 'Is the Mumbai to Kolhapur cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Kolhapur cab booking services to suit your travel schedule.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Kolhapur cab bookings?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols to ensure passenger safety.',
  },
  {
    question: 'What payment options are available for Mumbai to Kolhapur cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Kolhapur journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai to Kolhapur travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Prakash Mane',
    feedback: 'Our Mumbai to Kolhapur trip with Shambhu Cabs was very comfortable. The car was clean and the driver was very polite!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Radhika Jadhav',
    feedback: 'Highly reliable and professional Mumbai to Kolhapur cab service. Shambhu Cabs made our journey smooth and stress-free.',
    rating: 5,
  },
];










































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Kolhapur Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-kolhapur-cab.jpg",
  "description": "Shambhu Cabs offers safe and affordable Mumbai to Kolhapur cab services with professional drivers and well-maintained vehicles. Choose sedan, SUV, or premium cars for one-way or round-trip travel. Enjoy reliable, comfortable, and hassle-free intercity rides between Mumbai and Kolhapur.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-kolhapur-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Mumbai to Kolhapur Cab | Fast & Affordable Taxi Service | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Kolhapur cab services with Shambhu Cabs. Affordable fares, clean cars, expert drivers, and reliable intercity taxi options. Available 24×7 for one-way and round-trip Mumbai–Kolhapur travel."
  />

  <meta
    name="keywords"
    content="Mumbai Kolhapur Taxi Service, Kolhapur Mumbai One-Way Cab, Intercity Cab Mumbai Kolhapur, Mumbai to Kolhapur Car Rental, Best Cab Mumbai Kolhapur, Affordable Mumbai Kolhapur Taxi, Chauffeur Cab Mumbai Kolhapur, Sedan Cab Mumbai Kolhapur, SUV Cab Mumbai Kolhapur, Long-Distance Cab Mumbai Kolhapur, Mumbai Kolhapur Outstation Cab, 24×7 Taxi Mumbai Kolhapur, Premium Cab Mumbai Kolhapur, Mumbai Kolhapur Family Cab, Highway Cab Mumbai Kolhapur, Fast Mumbai Kolhapur Cab, Corporate Cab Mumbai Kolhapur, Safe Taxi Mumbai Kolhapur"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/4.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitokolhapurcabs;